import { Injectable, Injector } from '@angular/core';
import {
    ACondition,
    AObjectService,
    CacheService,
    ConfigurationService,
    MetadataService,
    PlatformService,
} from '@congacommerce/core';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { EglOrderLineItem } from '../../../../models/apttus/tables/order/egl-order-line-item';
import { LoadingService } from '../../../shared/loading.service';
@Injectable({
    providedIn: 'root',
})
export class EglOrderLineItemService extends AObjectService {
    constructor(
        cacheSrv: CacheService,
        plSrv: PlatformService,
        mtSrv: MetadataService,
        confSrv: ConfigurationService,
        inj: Injector,
    ) {
        super(cacheSrv, plSrv, mtSrv, confSrv, inj);
        this.setType(EglOrderLineItem);
    }

    updateDdlAndPublish(cart: EglOrderLineItem): Observable<EglOrderLineItem> {
        return this.update([cart]).pipe(
            take(1),
            map(([updatedCart]) => updatedCart as EglOrderLineItem),
            LoadingService.loaderOperator('Aggiornamento OLI'),
        );
    }

    getFieldInventory(id: string): Observable<EglOrderLineItem> {
        const conditions = [new ACondition(EglOrderLineItem, 'Id', 'Equal', id)];
        const searchRecords$ = this.query({
            conditions: conditions,
            cacheStrategy: 'performance',
        });
        return searchRecords$;
    }
}
